/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const StatusGeofenceWarning = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path
      d="M99.348 8.706c-11.618 0-21.039 9.42-21.039 21.039 0 .25.008.502.019.758a20.867 20.867 0 0 0 1.205 6.319c4.493 14.754 19.815 34 19.815 34s15.328-19.245 19.817-33.999a21.058 21.058 0 0 0 1.205-6.321c.01-.256.021-.509.021-.758 0-11.618-9.424-21.038-21.043-21.038zm0 31.344c-5.688 0-10.302-4.615-10.302-10.305s4.613-10.304 10.302-10.304c5.693 0 10.305 4.616 10.305 10.304-.001 5.69-4.612 10.305-10.305 10.305z"
    />
    <path d="M100.169 81.023l9.423-10.563h15.31l-16.369 15.53 17.626 15.795h-16.096l-9.735-10.779-9.733 10.779H75.286L92.085 85.99 75.716 70.46H90.91l9.259 10.563z" />
    <path
      d="M73.592 108.919a8.551 8.551 0 0 1-1.549-2.362c-.632-.204-1.229-.452-1.756-.776a41.663 41.663 0 0 1-16.034 3.198c-23.087 0-41.869-18.783-41.869-41.869 0-23.088 18.781-41.869 41.867-41.869 3.556 0 6.993.484 10.29 1.327a7.653 7.653 0 0 1 1.658-1.194c.069-.068.125-.145.197-.209-.304-2.497.313-5.122 1.845-7.085a9.437 9.437 0 0 1-.691-1.794c-4.251-1.122-8.695-1.768-13.298-1.768-28.999 0-52.592 23.594-52.592 52.594s23.594 52.594 52.592 52.594c7.62 0 14.841-1.683 21.38-4.619-.517-1.157-.778-2.43-.816-3.711-.549-.743-.926-1.585-1.224-2.457z"
    />
  </svg>
);

export default extendIcon(StatusGeofenceWarning);
